var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"draggableThing",style:({
      position: 'absolute',
      width: _vm.size + 'vw',
      height: _vm.size + 'vw'
    }),attrs:{"id":_vm.id}},[(_vm.src !== undefined)?_c('img',{attrs:{"type":"image/svg+xml","src":_vm.src}}):_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }